import { useQuery } from "react-query";

import { GET_CLIENT_DIAGNOSIS, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getClientDiagnosis } from "api/customers";

const useGetClientDiagnosis = (clientId) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_CLIENT_DIAGNOSIS, clientId],
    () => getClientDiagnosis(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  return {
    clientDiagnosis: data?.data || null,
    clientDiagnosisLoading: isLoading,
    refetchClientDiagnosis: refetch,
    ...rest,
  };
};

export default useGetClientDiagnosis;
